import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EpbtFaQuickPurchaseService } from '../../services/epbt-fa-quick-purchase.service';
import { EpbtFaBistrackbranchesListComponent } from '../../list/epbt-fa-bistrackbranches-list/epbt-fa-bistrackbranches-list.component';
import { Router, Data } from '@angular/router';
import { FieldAgentClient, QuickPurchase, SupplierSearchParameters, SupplierSearchParametersSupplierType, PagingParameters, SortParametersDirection, SortParameters } from 'ep-bt-field-agent-proxy';
import { IEpSearchBoxModel, EpButtonStyle, EpSearchBoxComponent, EpButtonSize, IEpTextBoxModel } from '@epicor/kinetic';
import { BistrackConfig } from 'ep-bt-controls';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-quick-purchase-suppliers',
  templateUrl: './epbt-fa-quick-purchase-suppliers.component.html',
  styleUrls: ['./epbt-fa-quick-purchase-suppliers.component.scss']
})
export class EpbtFaQuickPurchaseSuppliersComponent implements OnInit {
  EpButtonStyle = EpButtonStyle;
  EpButtonSize = EpButtonSize;

  searchParams: any;
  searchString: string;
  selectedBranchId: number;
  submitted = false;
  webTrackUser: any;
  quickPurchaseSupplierForm: FormGroup;

  @ViewChild(EpbtFaBistrackbranchesListComponent, { static: false }) branchesListComponent: EpbtFaBistrackbranchesListComponent;
  @ViewChild(EpSearchBoxComponent, { static: false }) epSearchBoxComponent: EpSearchBoxComponent;

  customerTextBoxModel: IEpTextBoxModel = {
    id: 'customerTextBoxModel',
    autoFocus: true
  };

  constructor(private formBuilder: FormBuilder,
    private config: BistrackConfig, private client: FieldAgentClient,
    private quickPurchaseService: EpbtFaQuickPurchaseService,
    private router: Router, private faService: EpbtFieldAgentService) { }

  ngOnInit() {
    // QuickPurchaseSupplierForm
    this.quickPurchaseSupplierForm = this.formBuilder.group({///
      supplierName: [''],
    });

    if (!this.quickPurchaseService.quickPurchase) {
      this.quickPurchaseService.quickPurchase = new QuickPurchase();
    }

    // Set Serch box value
    this.updateFromSupplierRecord(this.quickPurchaseService.quickPurchase.supplier);

    this.faService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;

      // Select brachId
      if (this.quickPurchaseService.quickPurchase.branchID) {
        this.selectedBranchId = this.quickPurchaseService.quickPurchase.branchID;
      } else {
        this.selectedBranchId = this.webTrackUser.bisTrackBranch.branchID;
        this.quickPurchaseService.quickPurchase.branch = this.webTrackUser.bisTrackBranch;
        this.quickPurchaseService.quickPurchase.branchID = this.webTrackUser.bisTrackBranch.branchID;
      }
    });
  }

  private updateFromSupplierRecord(supplier: any) {
    if (supplier) {
      // update form
      this.quickPurchaseSupplierForm.patchValue({
        supplierName: supplier.name
      });

      // update service; the "supplier" param may come from the service itself, in which case this statement is obsolete,
      // but in other cases (e.g. after search) this is needed
      this.quickPurchaseService.quickPurchase.supplier = supplier;
    }
  }

  onValueChange(selectedValue: any): void {
    if (selectedValue) {
      this.selectedBranchId = selectedValue.branchID;
      this.quickPurchaseService.quickPurchase.branch = selectedValue;
      this.quickPurchaseService.quickPurchase.branchID = selectedValue.branchID;
      this.quickPurchaseService.selectedProductsForBinding = []; // For clearing Brach selection.
      this.validate();
    }
  }

  validate() {
    if (this.selectedBranchId > 0) {
      this.quickPurchaseService.supplierFormFlag = true;
    } else {
      this.quickPurchaseService.supplierFormFlag = false;
    }

    // todo: supplier validation should be here
  }

  onSubmit() {
    this.submitted = true;
    this.validate();

    // todo: this code should eventually be a part of the currently missing supplier validation (see comment in the validate() function)
    this.getSuppliersBySearchString(this.quickPurchaseSupplierForm.value.supplierName).subscribe(res => {
      if (res && res.lines.length == 1) {
        this.updateFromSupplierRecord(res.lines[0]);
      }
      // else{
      //   todo: validation failed
      // }
    });
  }

  onSearchClick(event: any) {
    this.searchSupplier(event ? event.target.value : this.quickPurchaseSupplierForm.value.supplierName);
  }

  searchSupplier(searchString: string) {
    this.quickPurchaseService.isSuppliersSearchMessage = false;
    this.quickPurchaseService.searchSuppliersString = searchString;
    if (searchString) {
      this.getSuppliersBySearchString(searchString).subscribe(res => {
        if (res && res.lines.length == 1) {
          this.updateFromSupplierRecord(res.lines[0]);
        } else {
          this.router.navigate(['/home/quickpurchase/supplier']);
        }
      });
    } else {
      this.router.navigate(['/home/quickpurchase/supplier']);
    }
  }

  private getSuppliersBySearchString(search: string) {
    const parms = new SupplierSearchParameters();
    parms.supplierType = SupplierSearchParametersSupplierType.StockSupplier;
    parms.paging = new PagingParameters();
    parms.paging.index = 0;
    parms.paging.count = 50; // this.pageSize;
    parms.sorting = new SortParameters();
    parms.sorting.direction = SortParametersDirection.Ascending;
    parms.sorting.sortColumn = 'code';
    parms.searchText = search;
    return this.client.findSuppliers(parms);
  }

}
